import { Close } from '@mui/icons-material';
import { Box, Typography, IconButton } from '@mui/material';
import { ProfileHeaderProps } from './ProfileHeader.types';

/**
 * Profile header component displaying dialog title and close button
 * Shows different title text based on whether station is OKKO or competitor
 *
 * Features:
 * - Dynamic title based on station type (OKKO vs Competitor)
 * - Close button with icon
 * - Consistent styling with dialog header class
 *
 * @param props - Component props containing station type and close callback
 * @returns JSX element containing the profile dialog header
 */
export function ProfileHeader({ isOkkoStation, onClose }: ProfileHeaderProps): JSX.Element {
  return (
    <Box className="station-profile-dialog-header">
      <Typography className="station-profile-dialog-title">
        Профіль АЗК {isOkkoStation ? '(ОККО)' : '(Конкурент)'}
      </Typography>
      <IconButton onClick={onClose} className="station-profile-close-button">
        <Close />
      </IconButton>
    </Box>
  );
}
